import { z } from 'zod';
import { schemaDateHeure } from './commun';

const heure = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, 'Heure au format HH:MM');

/**
 * Catalogue des paramètres de collectivité (H9-01). Chaque clé a son schéma de valeur ;
 * une clé absente du catalogue est refusée.
 */
export const CATALOGUE_PARAMETRES = {
  identite_collectivite: z.object({
    nom_usuel: z.string().trim().min(2).max(200),
    adresse: z.string().trim().max(500).optional(),
    telephone: z.string().trim().max(40).optional(),
    courriel: z.string().trim().email().optional(),
    site_web: z.string().trim().url().optional(),
    /** Logo déposé par la collectivité (document PNG ou JPEG), repris dans l'en-tête des PDF. */
    logo_document_id: z.string().uuid().optional(),
  }),
  depot_documents: z.object({
    taille_max_mo: z.number().int().min(1).max(100),
  }),
  calendrier: z
    .object({
      jours_ouvres: z.array(z.number().int().min(1).max(7)).min(1).max(7),
      heure_ouverture: heure,
      heure_fermeture: heure,
    })
    .refine((v) => v.heure_fermeture > v.heure_ouverture, 'La fermeture suit l\'ouverture'),
  notifications_par_defaut: z.object({
    canaux: z.array(z.enum(['application', 'portail', 'courriel', 'sms', 'pwa'])).min(1),
  }),
  prefixe_numerotation: z.object({
    prefixe: z.string().regex(/^[A-Z0-9]{2,8}$/, 'Préfixe en majuscules et chiffres, 2 à 8 caractères'),
  }),
  /** Réclamations (lot L1-A, H7-03) : délai de réponse cible en jours ouvrés (15 par défaut). */
  reclamations: z.object({
    delai_reponse_jours: z.number().int().min(1).max(120),
  }),
} as const;
export type CleParametre = keyof typeof CATALOGUE_PARAMETRES;
export const CLES_PARAMETRES = Object.keys(CATALOGUE_PARAMETRES) as CleParametre[];

export const schemaEcritureParametre = z.object({
  valeur: z.unknown(),
  motif: z.string().trim().min(3, 'Motif obligatoire').max(500),
  date_effet: schemaDateHeure.optional(),
});

/** Format de numérotation par défaut (H3-01). */
export const FORMAT_NUMEROTATION_DEFAUT = 'PREFIXE-TYPE-AAAA-NNNNN';
